namespace e5.TransformMode {
    class TransformModeAuto implements ITransformMode {
        private _injectedElement: HTMLDivElement;
        private _rect: Rect = new Rect();
        private _injectRect: Rect = new Rect();
        constructor() {
            this._injectedElement = document.createElement("div");
            this._injectedElement.style.position = "absolute";
            this._injectedElement.style.left = "0";
            this._injectedElement.style.top = "0";
            this._injectedElement.style.transformOrigin = "0 0";
        }

        public extract(transform: Transform, matrix: Matrix3d): void {
            var globalBounds = Rect.getBounds(transform.element, this._rect);

            //Check if the element is matching the global bounds.
            if (globalBounds.width === transform.element.offsetWidth
                && globalBounds.height === transform.element.offsetHeight) {

                //Inject a element to top/left corner.
                var borderTop = Calc.parse(transform.style.borderTopWidth, 0);
                var borderLeft = Calc.parse(transform.style.borderLeftWidth, 0);
                borderLeft -= transform.element.scrollLeft;
                borderTop -= transform.element.scrollTop;
                var left = -borderLeft;
                var top = -borderTop;
                this._injectedElement.style.transform = "translate(" + left + "px, " + top + "px)";
                transform.element.appendChild(this._injectedElement);
                Rect.getBounds(this._injectedElement, this._injectRect);
                this._injectedElement.remove();

                //Check if the top/left corner of the injected element matches top global bounds top/left corner.
                if (this._injectRect.x === globalBounds.x && this._injectRect.y === globalBounds.y)
                    matrix.prependPosition(globalBounds.x, globalBounds.y, 0);
                else
                    Inject.extract(transform, matrix);
            }
            else {
                // console.log(transform.style.transform);
                Inject.extract(transform, matrix);
            }
        }
    }

    export const Auto = new TransformModeAuto();
}